import rGbp1 from "./gbp.webp";
import westField from "./westvillage.webp";

const ruko1 = { rGbp1, westField };

export default ruko1;
